module.exports = __webpack_public_path__ + "static/media/14UNEP27.7490014c.jpg";